import React, { useState } from 'react'
import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

function ViewPartner({ partner }) {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>

            <OverlayTrigger
                key="top"
                placement="top"
                overlay={
                    <Tooltip id="tooltip-top">
                        View
                    </Tooltip>
                }
            >
                <img src="/images/png/view.png" onClick={handleShow} className="pointer" width={35} alt="action" />
            </OverlayTrigger>

            <Modal show={show} className='custom-modal' size='lg' centered scrollable onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>View Partner</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row g-3">

                        <div className="col-12">
                            <Form.Label className='mb-0'>Name</Form.Label>
                            <p>{partner.name ? partner.name : "-"}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Email</Form.Label>
                            <p>{partner.email ? partner.email : "-"}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Phone Number</Form.Label>
                            <p>{partner.phone ? partner.phone : "-"}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Message</Form.Label>
                            <p>{partner.message ? partner.message : "-"}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Phone Number</Form.Label>
                            <p>{partner.phone ? partner.phone : "-"}</p>
                        </div>
                        <div className="col-12">
                            <Form.Label className='mb-0'>Enquiry Date</Form.Label>
                            <p>{partner.createdAt ? new Date(partner.createdAt).toLocaleString() : "-"}</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ViewPartner